var validatePhone = (value, _ref) => {
  var _props$mask;

  var {
    props
  } = _ref;
  var isPresent = Boolean(value.length);
  var patternRegEx = new RegExp(props.pattern);
  var demaskedLength = (_props$mask = props.mask) === null || _props$mask === void 0 ? void 0 : _props$mask.replace(/[^0]/g, '').length;
  var result = {
    patternMismatch: false,
    tooLong: isPresent && props.maxLength && demaskedLength < value.length,
    tooShort: isPresent && props.minLength && demaskedLength > value.length,
    valueMissing: !isPresent && [true, 'true'].includes(props.required)
  };

  if (Object.values(result).every(val => !val) && patternRegEx) {
    result.patternMismatch = !patternRegEx.test(value);
  }

  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = Boolean(!result.errors.length);
  return result;
};

export { validatePhone };